const config = {};

//---------------------------------------- Variable declaration ------------------------------------------------------

config.api                                    = {};

//-------------------------------------- Seting variables -------------------------------------------------------------

config.api.baseUrl                            = process.env.VUE_APP_BACKEND_URL || 'http://waitai-local.es:3000';

module.exports = config;

